<template>
  <v-list two-line>
    <div v-for="(file, index) in list" :key="'file_'+index">
      <v-divider
          v-if="index > 0"
          :key="'file_line_'+index"
      ></v-divider>
      <v-list-item
          dense
          :key="'file_item_'+index"
      >
        <v-list-item-content>
          <v-list-item-title v-text="file.name"/>
          <v-list-item-subtitle v-text="file.sizeMb"/>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn depressed icon color="error" @click="emitRemove(index)" :disabled="disabled">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
export default {
  name: 'Attachments',
  props: ['list', 'disabled'],
  data: () => ({

  }),
  methods: {
    emitRemove(index) {
      this.$emit('remove-emit', index)
    }
  }
}
</script>